import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:text-14" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "flex justify-center gap-x3" }
const _hoisted_4 = ["href"]

import useCountries from '@/shared/address/useCountries';
import pageStore from '@/shared/content/page.store';
import { computed, onUnmounted, ref, Ref, watch } from 'vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { hardRedirect } from '@/core/navigation/redirect.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'InternationalCountryPicker',
  setup(__props) {


const globalLabels = useGlobalLabels(GlobalLabels.countryPicker);
const {
    getSuggestedCountry,
    getCountryNameFromCode,
    redirectToSuggestCountrySite,
    loaded,
} = useCountries();

const countryPickerRef: Ref<HTMLElement | null> = ref(null);

watch(countryPickerRef, (topBarRef) => {
    if (countryPickerRef.value) {
        pageStore.setInternationalCountryPickerHeight(countryPickerRef.value?.clientHeight);
    } else {
        pageStore.setInternationalCountryPickerHeight(0);
    }
});

// Wait for country names to be loaded
watch(loaded, async(isLoaded) => {
    if (isLoaded && pageStore.showInternationalCountryPicker()) {
        suggestedCountryCode.value = await getSuggestedCountry();
    }
}, { immediate: true });

const suggestedCountryCode: Ref<string> = ref('');

const suggestedCountryName = computed(() => {
    const suggestedCountryName = getCountryNameFromCode(suggestedCountryCode.value);
    return suggestedCountryName === suggestedCountryCode.value ? null : suggestedCountryName;
});

const acceptSuggestedCountrySite = () => {
    redirectToSuggestCountrySite(suggestedCountryCode.value).then((newPathName: string) => {
        if (newPathName) {
            hardRedirect(newPathName);
        }
    });
};
const showCountryPicker = ref(true);
const closeCountryPicker = () => {
    showCountryPicker.value = false;
};

onUnmounted(() => showCountryPicker.value = true);


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_unref(pageStore).showInternationalCountryPicker() && _unref(suggestedCountryName) && showCountryPicker.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "countryPickerRef",
        ref: countryPickerRef,
        class: "bg-wild-sand py-x2 px-x3 flex flex-col items-center gap-x3 z-overlay relative lg:z-top-bar"
      }, [
        _createElementVNode("button", {
          type: "button",
          "aria-label": "close",
          class: "absolute top-0 right-0 p-15 mr-7 outline-none focus:outline-none",
          onClick: closeCountryPicker
        }, [
          _createVNode(_component_c_icon, {
            name: "icon-plus",
            class: "rotate-45 h-14 w-14"
          })
        ]),
        _createElementVNode("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(globalLabels).weThinkYouAreFrom) + " ", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(suggestedCountryName)), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "c-button border-black flex-shrink-0 flex items-center lg:text-14",
            href: _unref(pageStore).changeCountryUrl
          }, _toDisplayString(_unref(globalLabels).selectAnotherCountry), 9, _hoisted_4),
          _createElementVNode("button", {
            class: "c-button c-button--basket lg:text-14",
            onClick: acceptSuggestedCountrySite
          }, _toDisplayString(_unref(globalLabels).acceptSuggestedCountry), 1)
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})